import { render, staticRenderFns } from "./Ten.vue?vue&type=template&id=2b12e3c2&scoped=true&"
import script from "./Ten.vue?vue&type=script&lang=ts&"
export * from "./Ten.vue?vue&type=script&lang=ts&"
import style0 from "./Ten.vue?vue&type=style&index=0&id=2b12e3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b12e3c2",
  null
  
)

export default component.exports